import { Component, OnInit, Signal } from '@angular/core';

import { expandCollapseAnimation } from '../shared/animations/expand-collapse.animation';
import { ClaimNumberService } from '../shared/services/claim-number/claim-number.service';
import { LogoutService } from '../shared/services/logout/logout.service';

/**
 * Component for the app breadcrumb trail.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-breadcrumbs',
	standalone: true,
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.css'],
	animations: [expandCollapseAnimation({ delayEnterMS: 300 })]
})
export class BreadcrumbsComponent implements OnInit {
	claimNumberSig: Signal<string | null>;

	/**
	 * @param claimNumberService the global claim number service
	 * @param logoutService the global logout service
	 */
	constructor(
		private claimNumberService: ClaimNumberService,
		private logoutService: LogoutService
	) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.claimNumberSig = this.claimNumberService.getClaimNumber();
	}

	/**
	 * To navigate back to the 'Track-a-Claim' page, we need to log the user out, which then will trigger the page
	 * navigation.
	 */
	goBack() {
		this.logoutService.logout();
	}
}
